var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M24 9.5c3.9 0 7.3 1.6 9.7 4.1l7.3-7.3C36.1 2.2 30.4 0 24 0 14.6 0 6.4 5.2 2.4 12.8l8.5 6.6C13 12.4 18.1 9.5 24 9.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M46.1 24.5c0-1.7-.1-3.3-.4-4.9H24v9.3h12.5c-.5 2.8-2.1 5.2-4.5 6.9l7 5.4c4.1-3.8 6.4-9.5 6.4-16.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A90E2",
    d: "M13.9 28.5c-.9-2.6-.9-5.4 0-8l-8.5-6.6C2.2 17.9 0 21.7 0 24s2.2 6.1 5.4 10.1l8.5-5.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M24 48c6.5 0 12.1-2.1 16.2-5.7l-7-5.4c-2 1.3-4.6 2.1-7.2 2.1-5.9 0-11-3.9-12.8-9.3l-8.5 5.6C6.4 42.8 14.6 48 24 48z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.112368b67b5f629f7469bb2de366278f.svg";
export { ForwardRef as ReactComponent };